import { useEffect, useRef, useState } from "react";

// Font Awesome Icons
import { faBars, faDatabase, faXmark, faUsers, faCalculator, faChevronDown, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const Header = () => {
    const [navOpen, setNavOpen] = useState(false);
    const [toolsOpen, setToolsOpen] = useState(false);
    const toolsRef = useRef<HTMLLIElement>(null);

    const closeNavBar = () => {
        setNavOpen(false);
        setToolsOpen(false);

        const navbar = document.getElementById('navbarNav');
        if (navbar) {
            navbar.classList.remove('show');
        }
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (toolsRef.current && !toolsRef.current.contains(event.target as Node)) {
                setToolsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="navbar-wrap sticky-top">
            <nav className={`navbar navbar-expand-lg navbar-light`}>
                <a className="navbar-brand" href="/">SponsorDB <FontAwesomeIcon className="nav-icon" icon={faDatabase} />
                </a>
                <button onClick={() => setNavOpen(!navOpen)} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <FontAwesomeIcon className="nav-icon" icon={navOpen ? faXmark : faBars} />
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav">
                        {/* <li className="nav-item">
                            <a className="nav-link" href="/#sample-data" onClick={closeNavBar}>Database</a>
                        </li> */}
                        <li className="nav-item">
                            <a className="nav-link" href="/#pricing" onClick={closeNavBar}>Pricing</a>
                        </li>
                        {/* <li className="nav-item">
                            <a className="nav-link" href="/#testimonials" onClick={closeNavBar}>Testimonials</a>
                        </li> */}
                        <li className="nav-item">
                            <a className="nav-link" href="/#FAQ" onClick={closeNavBar}>FAQ</a>
                        </li>

                        {/* Blog intentionally isn't in primary nav — thin, dated AI-written
                            content isn't what should pull visitor attention away from the
                            product. Still linked from the footer (and still routable) for
                            whatever crawl/SEO value it has; see NicheLanding for the actual
                            organic-growth bet instead. */}

                        {/* Desktop: dropdown with 3 sub-links. Mobile: same list, just
                            renders inline (no dropdown chrome needed once it's already
                            inside the collapsed hamburger menu). */}
                        <li className="nav-item nav-item--tools" ref={toolsRef}>
                            <button
                                type="button"
                                className={`nav-link nav-link--tools-toggle ${toolsOpen ? 'open' : ''}`}
                                onClick={() => setToolsOpen(!toolsOpen)}
                                aria-expanded={toolsOpen}
                                aria-haspopup="true"
                            >
                                Free Tools
                                <FontAwesomeIcon icon={faChevronDown} className="nav-link--tools-toggle__chevron" />
                            </button>
                            <ul className={`tools-dropdown ${toolsOpen ? 'tools-dropdown--open' : ''}`}>
                                <li>
                                    <Link to="/tools#free-sponsors" onClick={closeNavBar}>
                                        <FontAwesomeIcon icon={faUsers} /> Search Sponsors by Niche
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/tools#rate-calculator" onClick={closeNavBar}>
                                        <FontAwesomeIcon icon={faCalculator} /> Rate Calculator
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/newsletter/" onClick={closeNavBar}>
                                        <FontAwesomeIcon icon={faEnvelope} /> Weekly Sponsor Report
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li className="nav-item  nav-item__highlight">
                            <Link className="nav-link nav-link__highlight " to="/signup" onClick={closeNavBar}>Get Started</Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    );
}

export default Header;